"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRIGGER = "trigger";
exports.RESOURCE = "resource";
exports.ACTION = "action";
exports.FILTER = "filter";
exports.NOTIFICATION = "notification";
exports.USER_APPROVAL = "userapproval";
exports.DELAY = "delay";
exports.CUSTOM = "custom";
exports.REPORT = "report";
exports.MONITORING = "monitoring";
exports.HTTP = "http";
exports.JENKINS = "jenkins";
exports.WORKFLOW = "workflow";
exports.WORKFLOW_REPORT = "workflowReport"; // not active
//export const ENRICHMENT = "enrichment"; // not active
//export const LOGICAl = "logical"; // not active
//export const VISUALIZATION = "visualization"; // not active
//export const AUGMENTATION = "augmentation"; // not active
exports.THROTTLING = "throttling";
exports.ADOPTION = "adoption";
exports.SSH = "ssh";
exports.NETWORK = "network";
exports.WOLKEN = "wolken";
exports.VMWARE = "vmware";
exports.VMWARE_ACTION = "vmware-action";
exports.Azure_Resource = "azure-resource";
exports.Azure_Action = "azure-action";
exports.Azure_Monitoring = "azure-monitoring";
exports.K8_Resource = "kubernetes-resource";
exports.K8_Action = "kubernetes-action";
exports.Decision = "decision";
exports.Parallel = "parallel";
exports.TerraformCloudResource = "terraform-cloud-resource";
exports.TerraformCloudAction = "terraform-cloud-action";
exports.UserDefinedNode = "user-defined-node";
exports.DataFormatter = "data-formatter";
exports.DataJoiner = "data-joiner";
exports.GCP_Resource = "gcp-resource";
exports.GCP_Action = "gcp-action";
//# sourceMappingURL=NodeTypes.js.map
